import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = ({ onReserveClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Inicio', href: '/#inicio' },
    { name: 'Habitaciones', href: '/#habitaciones' },
    { name: 'Experiencias', href: '/#experiencias' },
    { name: 'Reseñas', href: '/#resenas' },
    { name: 'Contacto', href: '/#contacto' },
  ];

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        backgroundColor: scrolled ? 'rgba(255, 255, 255, 0.98)' : 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(10px)',
        transition: 'all 0.4s ease',
        boxShadow: scrolled ? '0 2px 10px rgba(0,0,0,0.1)' : 'none'
      }}
    >
      <div style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '80px'
      }}>
        {/* Logo */}
        <div>
          <h1 style={{
            fontSize: '1.5rem',
            fontFamily: 'Playfair Display, serif',
            fontWeight: 'bold',
            color: scrolled ? '#1a1a1a' : '#ffffff',
            margin: 0,
            transition: 'color 0.3s'
          }}>
            Sumaq Mayu
          </h1>
        </div>

        {/* Desktop Menu */}
        <div style={{
          display: 'none',
          alignItems: 'center',
          gap: '2.5rem'
        }} className="desktop-menu">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className={`
                ${scrolled ? 'text-gray-700' : 'text-white'}
                hover:${scrolled ? 'text-gray-900' : 'text-gray-200'}
                text-base font-medium no-underline relative py-2
                transition-all duration-300 group
              `}
            >
              {item.name}
              <span className="absolute bottom-0 left-0 w-full h-[2px] bg-jungle-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out"></span>
            </a>
          ))}
          <button
            onClick={onReserveClick}
            className={`
              py-3 px-8 text-sm font-semibold tracking-wider border-none cursor-pointer
              transition-all duration-300 rounded-md
              hover:shadow-lg hover:-translate-y-1 transform focus:outline-none focus:ring-2 focus:ring-jungle-500 focus:ring-opacity-50
              ${scrolled 
                ? 'bg-gray-900 text-white hover:bg-jungle-700' 
                : 'bg-white text-gray-900 hover:bg-jungle-500'
              }
            `}
          >
            RESERVAR
          </button>
        </div>

        {/* Mobile menu button */}
        <div style={{ display: 'none' }} className="mobile-menu-btn">
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: scrolled ? '#1a1a1a' : '#ffffff',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div style={{
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }} className="mobile-menu-content">
          <div style={{
            padding: '1.5rem 2rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}>
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                style={{
                  color: '#4a5568',
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  textDecoration: 'none',
                  padding: '0.75rem',
                  borderRadius: '4px',
                  transition: 'background 0.3s'
                }}
                onClick={() => setIsOpen(false)}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f7fafc';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                {item.name}
              </a>
            ))}
            <button
              onClick={() => {
                onReserveClick();
                setIsOpen(false);
              }}
              style={{
                backgroundColor: '#1a1a1a',
                color: '#ffffff',
                padding: '0.9rem',
                fontSize: '0.85rem',
                fontWeight: 600,
                letterSpacing: '0.05em',
                border: 'none',
                cursor: 'pointer',
                marginTop: '0.5rem',
                borderRadius: '2px'
              }}
            >
              RESERVAR
            </button>
          </div>
        </div>
      )}

      <style>{`
        @media (min-width: 768px) {
          .desktop-menu {
            display: flex !important;
          }
          .mobile-menu-btn {
            display: none !important;
          }
          .mobile-menu-content {
            display: none !important;
          }
        }
        @media (max-width: 767px) {
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
